import { handleActions } from "redux-actions";
import {
  dadataSearch,
  dadataSearchSuccess,
  dadataSearchFailure,
  dadataSet,
  dadataIdle,
  dadataClearSelected,
} from "../../actions/daData";
import { combineReducers } from "redux";

const result = handleActions(
  {
    [dadataSearchSuccess]: (state, { payload }) => payload
  },
  []
);

const selected = handleActions(
  {
    [dadataSet]: (state, { payload }) => payload,
    [dadataClearSelected]: state => null,
    [dadataIdle]: () => {
      return {};
    }
  },
  {}
);

const status = handleActions(
  {
    [dadataSearch]: () => "LOADING",
    [dadataSearchSuccess]: () => "SUCCESS",
    [dadataSearchFailure]: () => "FAILURE"
  },
  "IDLE"
);

export const dadata = combineReducers({
  result,
  status,
  selected
});
